import { redirect, useLoaderData, useNavigate } from 'react-router'
import { Flex } from '@radix-ui/themes'
import { PageHeading } from '@/components/subscription/page-heading'
import { formatDate } from '@/lib/shipment'
import { InBulkProduct } from '@/components/in-bulk-product'
import { TextLink } from '@/components/subscription/text-link'
import { createClient, JSONAPIResponse } from '@/api-client'
import { Subscriptions } from '@/api-client/Subscriptions'
import * as styles from './styles.css'

export const loader = async () => {
  const subscriptions = (await fetchSubscriptions()) as unknown as JSONAPIResponse<typeof fetchSubscriptions>
  const subscription = subscriptions.data.data[0]

  if (subscription) {
    const placements = await fetchPlacements(subscription.id)
    const product = await fetchProduct(subscription.id)

    return [subscriptions, placements, product]
  } else {
    return redirect('/subscription/mypage')
  }
}

function fetchSubscriptions() {
  return createClient(Subscriptions).getSubscriptions()
}

function fetchPlacements(id: string) {
  return createClient(Subscriptions).getSubscriptionsSubscriptionIdPlacements(id)
}

function fetchProduct(id: string) {
  return createClient(Subscriptions).getSubscriptionsSubscriptionIdProduct(id)
}

export const SubscriptionMypageBulk: React.FC = () => {
  const navigate = useNavigate()
  const [subscriptions, placements, product] = useLoaderData() as [
    JSONAPIResponse<typeof fetchSubscriptions>,
    JSONAPIResponse<typeof fetchPlacements>,
    JSONAPIResponse<typeof fetchProduct>,
  ]

  const subscription = subscriptions.data.data[0]
  const nextPlacement = placements?.data?.data?.[0]
  const deliverDate = nextPlacement?.attributes?.ship_at ? formatDate(nextPlacement.attributes.ship_at * 1000, 'M/d（E）') : null
  const products = product?.data?.included?.filter((item: any) => item.type === 'flower_collection_product') ?? []

  const addProduct = async (productId: string) => {
    await createClient(Subscriptions).postSubscriptionsSubscriptionIdInBulkProducts(subscription.id, { flower_collection_product_id: productId })
    await navigate(`/subscription/mypage/bulk/done?product_id=${productId}`)
  }

  return (
    <Flex direction="column" align="center" gap="32px">
      <PageHeading>グッズ一覧</PageHeading>
      <Flex direction="column" align="center" gap="24px">
        <Flex direction="column" align="center" gap="8px">
          {deliverDate && <p className={styles.subtitle}>{deliverDate}のお届け分のお花に<wbr />同梱されます</p>}
          <p className={styles.description}>
            フローリストがおすすめできる商品を厳選！
            <br />
            一度に追加できるグッズは1点までです
          </p>
        </Flex>
        <div className={styles.grid}>
          {products.map((item: any) => (
            <InBulkProduct
              key={item.id}
              product={item}
              buttonTitle="追加注文する"
              buttonColor="inverted"
              selected={false}
              onSelect={() => addProduct(item.id)}
              onUnselect={() => {}}
            />
          ))}
        </div>
      </Flex>
      <TextLink to="/subscription/mypage">マイページに戻る</TextLink>
    </Flex>
  )
}
